<script>
/**
 * 文の中の **ここ** を太字にして出す。
 *
 * ヘルプ本文と取込の注意書きは、強調したいところを ** で書いている。
 * {{ }} でそのまま出していたので、<b>記号のまま画面に出ていた</b>
 * （ヘルプ5ファイル34か所・取込の注意書き、2026-09-13）。
 *
 * **v-html は使わない。**本文に < や & が入っても、文字のまま出す。
 * 閉じていない ** は、記号のまま残す（そこから先がずっと太字にならないように）。
 */
export default {
  name: 'EmphasisText',
  functional: true,
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  render (h, { props }) {
    const text = String(props.text || '')
    const parts = text.split('**')
    if (parts.length % 2 === 0) {
      return h('span', text)
    }
    return h('span', parts
      .map((part, index) => (index % 2 === 1 ? h('strong', part) : part))
      .filter(part => part !== ''))
  }
}
</script>
